import React from 'react';
import PickerItem from './PickerItem';
import Avatar from '../../../components/Avatar';
export default function UserPickerItem(_ref) {
  var user = _ref.user,
      _ref$index = _ref.index,
      index = _ref$index === void 0 ? 0 : _ref$index,
      _ref$isSelected = _ref.isSelected,
      isSelected = _ref$isSelected === void 0 ? false : _ref$isSelected,
      _ref$onSelectItem = _ref.onSelectItem,
      onSelectItem = _ref$onSelectItem === void 0 ? function () {} : _ref$onSelectItem,
      _ref$onClickItem = _ref.onClickItem,
      onClickItem = _ref$onClickItem === void 0 ? function () {} : _ref$onClickItem;
  return React.createElement(PickerItem, {
    "data-toolbar": "mention-picker-user-".concat(user.id),
    key: user.id,
    index: index,
    isSelected: isSelected,
    onMouseMove: onSelectItem,
    onClick: onClickItem,
    renderTitle: function renderTitle() {
      return '@'.concat(user.username);
    },
    renderSubtitle: function renderSubtitle() {
      return user.displayName;
    },
    renderIcon: function renderIcon(_ref2) {
      var width = _ref2.width;
      return React.createElement("div", {
        className: "flexbox-no-grow flexbox-no-shrink",
        style: {
          width: width,
          height: width
        }
      }, React.createElement(Avatar, {
        url: user.photoURL,
        name: user.displayName,
        size: 'small'
      }));
    }
  });
}